"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SceneRenderer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("motion/react");
var _propTypes = require("prop-types");
var _PropTypes = require("./PropTypes");
var _LayerSource = _interopRequireDefault(require("./LayerSource"));
var _Background = require("./Background");
var _Tile = require("../Tile");
var _excluded = ["serverTime", "serverTimeDelta", "layers", "componentMap", "style", "sourceHoverComponent", "hasBorderRadius", "disableStageBorderRadius", "enableRetry", "AttendeeTileComponent"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Default layer animation
var layerAnimation = {
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0
  },
  transition: {
    duration: 1
  }
};

/**
 * Optional
 * @param {number} serverTime
 * @param {number} serverTimeDelta
 * @param {Array<object>} layers
 * @param {object} componentMap provide a component map to tell the scene renderer to render various source types. See DefaultComponentMap
 * @param {object} style
 * @param {element} sourceHoverComponent
 * @param {boolean} hasBorderRadius
 * @param {boolean} disableStageBorderRadius
 * @param {boolean} enableRetry
 * @param AttendeeTileComponent
 * @param {object} rest
 */
var SceneRenderer = exports.SceneRenderer = function SceneRenderer(_ref) {
  var serverTime = _ref.serverTime,
    serverTimeDelta = _ref.serverTimeDelta,
    layers = _ref.layers,
    componentMap = _ref.componentMap,
    style = _ref.style,
    sourceHoverComponent = _ref.sourceHoverComponent,
    hasBorderRadius = _ref.hasBorderRadius,
    disableStageBorderRadius = _ref.disableStageBorderRadius,
    enableRetry = _ref.enableRetry,
    _ref$AttendeeTileComp = _ref.AttendeeTileComponent,
    AttendeeTileComponent = _ref$AttendeeTileComp === void 0 ? _Tile.AttendeeTile : _ref$AttendeeTileComp,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(!document.hidden),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isTabActive = _useState2[0],
    setIsTabActive = _useState2[1];
  (0, _react.useEffect)(function () {
    var handleVisibilityChange = function handleVisibilityChange() {
      setIsTabActive(!document.hidden);
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return function () {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
  (0, _react.useEffect)(function () {
    // Disable animations when the tab is not active
    // When the tab is not active, browsers tend to throttle JS execution
    // which can lead to janky or skipped animations
    _react2.MotionGlobalConfig.skipAnimations = !isTabActive;
  }, [isTabActive]);
  var cameraPresenterLayersCount = layers.filter(function (item) {
    return item.source.type === 'cameraPresenter';
  }).length;
  return /*#__PURE__*/_react["default"].createElement(_Background.Background, {
    style: style,
    disableStageBorderRadius: disableStageBorderRadius,
    enableRetry: enableRetry
  }, /*#__PURE__*/_react["default"].createElement(_react2.AnimatePresence, null, layers.filter(function (nextLayer) {
    return !!nextLayer;
  }).map(function (_ref2) {
    var layer = _ref2.layer,
      source = _ref2.source;
    var sourceId = source._id;
    return /*#__PURE__*/_react["default"].createElement(_LayerSource["default"]
    // It's crucial that key is unique
    , (0, _extends2["default"])({
      key: "source-id-wrapper-".concat(sourceId)
    }, _objectSpread(_objectSpread({
      serverTime: serverTime,
      serverTimeDelta: serverTimeDelta,
      layer: layer,
      source: source,
      componentMap: componentMap,
      cameraPresenterLayersCount: cameraPresenterLayersCount
    }, rest), {}, {
      animation: (layer === null || layer === void 0 ? void 0 : layer.animation) || layerAnimation
    }), {
      hoverComponent: sourceHoverComponent,
      hasBorderRadius: hasBorderRadius,
      AttendeeTileComponent: AttendeeTileComponent
    }));
  })));
};
SceneRenderer.defaultProps = {
  showMediaControls: false,
  autoPlayMedia: false,
  // @deprecated see below comments on `mediaPlayer/audioPlayer`
  mediaPlayer: {},
  hoverComponent: null,
  // @deprecated see below comments on `mediaPlayer/audioPlayer`
  audioPlayer: {},
  style: {
    backgroundImage: '',
    background: ''
  },
  hasBorderRadius: true,
  disableStageBorderRadius: false,
  enableRetry: false
};
SceneRenderer.propTypes = {
  layers: _PropTypes.LayerSourceList,
  componentMap: _propTypes.object,
  showMediaControls: _propTypes.bool,
  // @deprecated in favor of source.value.isPlaying (see below comments on `mediaPlayer`)
  autoPlayMedia: _propTypes.bool,
  onTogglePlayback: _propTypes.func,
  onToggleAudioPlayback: _propTypes.func,
  onVolumeChanged: _propTypes.func,
  onSeekTimeChanged: _propTypes.func,
  serverTime: _propTypes.number,
  serverTimeDelta: _propTypes.number,
  /**
   * @deprecated, we are transitioning to use source properties instead. Example:
   *
   *    const videoSource = {
          _id: "someSourceId",
          value: {
            url: String,
            isPlaying: Boolean,
            loop: Boolean,
            startedOn: Timestamp
          }
        }
         const deprecatedVideoSource = {
          _id: String,
          value: String //maps to videoSource.value.url
        }
      If the videoSource is in the _new_ format, the `mediaPlayer` property will be ignored
   */
  mediaPlayer: _PropTypes.MediaPlayer,
  sourceHoverComponent: _propTypes.element,
  /**
   * @deprecated, we are transitioning to use source properties instead. see above on `mediaPlayer`
   */
  audioPlayer: _PropTypes.AudioPlayer,
  style: _propTypes.object,
  hasBorderRadius: _propTypes.bool,
  disableStageBorderRadius: _propTypes.bool,
  enableRetry: _propTypes.bool,
  AttendeeTileComponent: _propTypes.elementType
};